import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { DealerMasterComponent } from './dealer-master.component';

const routes: Routes = [
  {
    path: 'dealer-master',
    data: { name: 'Dealer Master', isTab: true },
    component: DealerMasterComponent,
  },
];
@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class DealerMasterRoutingModule {}
